import React from 'react';
import { UpgradeAccountModal } from '../../components/UpgradeAccount/UpgradeAccountModal';
import { ROUTES } from '../../const/routes';

interface ModalData {
	message: string;
	title: string;
	okText?: string;
	stepper: {
		prefix?: string;
		suffix?: string;
		steps: number;
		passedSteps: number;
	};
}

export const useUpgradeAccountModal = () => {
	const [isOpen, setIsOpen] = React.useState(false);
	const [modalData, setModalData] = React.useState<ModalData | null>(null);

	const closeModal = () => {
		setIsOpen(false);
	};

	const modal = (
		<UpgradeAccountModal
			open={isOpen}
			message={modalData?.message ?? ''}
			title={modalData?.title ?? 'Vylepšit účet'}
			onOk={closeModal}
			onCancel={closeModal}
			okText={modalData?.okText ?? 'Vylepšit účet'}
			linkTarget={`${ROUTES.APP.TIER}`}
			stepper={modalData?.stepper ?? { prefix: '', steps: 0, passedSteps: 0 }}
		/>
	);

	return {
		openUpgradeAccountModal: (data: ModalData) => {
			setModalData(data);
			setIsOpen(true);
		},
		upgradeAccountModal: modal,
	};
};
